import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import  './Resources/Actions.css';
import './App.css';


export default function Dayclosing(){
    const navigate = useNavigate();
    const date = new Date().toISOString().slice(0,10);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const[ramount, setRamount] = useState([]);
    const[intamount, setIntamount] = useState([]);
    const[fineamount,setFineamount] = useState([]);
    const[prvamount,setPrvamount]= useState([]);
    const[docamount,setDocamount] = useState([]);
    const[expamount, setExpamount] = useState([]);
    let pamount = 0;
    let capital = 0;

useEffect(()=>{
    fetch(API_URL+"api/Dayclosing/DayClosing?date="+ document.getElementById('ldate').value)
    .then(response => response.json())
    .then(data => {setPrvamount(data)}); 
},[])

console.log(prvamount);

function fetchdetails()
{
    if (prvamount[0].Closing_Date.slice(0,10) < document.getElementById('ldate').value)
    {
   
    fetch(API_URL+"api/Payment/GetDailyCollection?rdate="+document.getElementById('ldate').value)
        .then(response => response.json())
        .then(data => {setRamount(data)});
    
    fetch(API_URL+"api/Interest/GetInterestList?sdate="+document.getElementById('ldate').value +"&edate="+document.getElementById('ldate').value)
        .then(response => response.json())
        .then(data => {setIntamount(data)});
        
    fetch(API_URL+"api/Fine/GetFine?sdate="+document.getElementById('ldate').value +"&edate="+document.getElementById('ldate').value)
        .then(response => response.json())
        .then(data => {setFineamount(data)});

    fetch(API_URL+"api/Loan/GetLoanList?sdate="+document.getElementById("ldate").value+"&edate="+document.getElementById("ldate").value)
        .then(response => response.json())
        .then(data => {setDocamount(data)});

    fetch(API_URL+"api/Expense/GetExpenses?sdate="+document.getElementById('ldate').value +"&edate="+document.getElementById('ldate').value)
        .then(response => response.json())
        .then(data => {setExpamount(data)});
    }
    else
    {
        alert("Day Closed already Done for this Date");
    }
}

        const daycollection = ramount.reduce((tot,el)=>tot+ el.RAmount,0);
        const interest = intamount.reduce((tot,el)=>tot+ el.InterestAmount,0);
        const fine = fineamount.reduce((tot,el)=>tot+ el.FineAmount,0);
        const docfee = docamount.reduce((tot,el)=>tot+ el.DocumentFee,0);
        const loan = docamount.reduce((tot,el)=>tot+ el.LoanAmount,0);
        const Expense = expamount.reduce((tot,el)=>tot+ el.ExpenseAmount,0);
        {prvamount.length > 0 ?
         pamount = prvamount[0].Balance : pamount = 0 }
        {prvamount.length > 0 ? 
        capital = prvamount[0].Capital : capital = 0}
         

function confirmclosing()
{
        const cbalance =  daycollection + interest + fine + docfee + pamount + capital - loan - Expense;
        console.log(cbalance);
        const data = new FormData();
        data.append("ddate",date);
        data.append("damount",cbalance);
        data.append("dcamount",0);

        fetch(API_URL+"api/Dayclosing/EnterDcBalance",{method:"POST",body:data})
           .then(response => response.json())
           .then(()=>{});

           showOKdialog();
} 

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}


return(
    <>
    <div className="reportheader"> 
            Day Closing Report
            <Navbar/>
    </div>      
    <label for="ldate"  style={{marginTop:"15px",marginLeft:"20px"}}>Date</label>
        <input id="ldate" aria-readOnly = "true" type="date"  defaultValue = {date} style={{height:"25px",width:"200px",marginTop:"15px",marginLeft:"15px"}}></input><br/><br/>
        <label for="user" style={{marginTop:"10px"}}>User ID</label>
        <input id="user" style={{height:"25px",width:"200px",marginTop:"5px",marginLeft:"15px"}}></input>
        <button type = "button"  style ={{height:"33px",width:"20%",marginLeft:"15px",marginTop:"10px",backgroundColor:"orange", color:"white",fontSize:"14px",fontWeight:"bolder", borderRadius:"5px"}} onClick={()=>{fetchdetails()}}>Fetch</button>
    <fieldset style={{marginTop:"15px",marginBottom:"15px"}}>
    <legend>Credit</legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>
            Day Collection
            </td>
            {ramount.length > 0 ?
            <td id = "daycollection">{daycollection}</td> :
            <td id = "daycollection">0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Fine Amount</td>
            {fineamount.length > 0 ? 
            <td>{fine}</td> :
            <td id = "fineamount"> 0 </td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>interest</td>
            {intamount.length > 0 ?
            <td>{interest}</td>:
            <td id ="interest" >0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Document Fee</td>
            {docamount.length > 0 ? 
            <td>{docfee}</td>:
            <td id = "documentfee">0</td>}
        </tr>
        <tr>
            <td style={{width:"50%",textAlign:"left",fontWeight:"bolder"}}>Previous Day Closing</td>
            <td id="pdclosing" >{pamount}</td>
        </tr>
        <tr>
            <td style={{width:"50%",textAlign:"left",fontWeight:"bolder"}}>New Capital In</td>
            <td id="capital" >{capital}</td>
        </tr>
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Credit Total</td>
            <td style={{fontWeight:"bolder"}}>{daycollection+interest+fine+docfee+pamount+capital}</td>
        </tr>
    </table>
</fieldset>
<fieldset style={{marginBottom:"15px"}}>
    <legend>Debit </legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>
            Loan Distripution
            </td>
            {docamount.length > 0 ?
            <td>{loan}</td>:
            <td>0</td>}
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Expenses</td>
            {expamount.length > 0 ?
            <td>{Expense}</td>:
            <td>0</td>}
        </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Debit Total</td>
            <td style={{fontWeight:"bolder"}}>{loan + Expense}</td>
        </tr>

    </table>
</fieldset>
<fieldset style ={{marginBottom:"30px"}}>
    <legend>Closing</legend>
    <table style={{width:"100%"}}>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Credit</td>
            <td style={{fontWeight:"bold"}}>{daycollection+interest+fine+docfee+pamount+capital}</td>
        </tr>
        <tr>
            <td style={{textAlign:"left", width:"50%"}}>Debit</td>
            <td style={{fontWeight:"bold"}}>{loan + Expense}</td>
        </tr>
        
        <tr>
            <td style={{width:"50%",fontWeight:"bolder"}}>Closing Balance</td>
            <td id="dayclose" style={{fontWeight:"bolder"}}> {daycollection+interest+fine+docfee+pamount+capital-loan-Expense} </td>
        </tr>

    </table>
</fieldset>
        <button type = "button"  className="actionbuttons" onClick={()=>{confirmclosing()}}>Confirm</button> 
        <button type = "button"  className= 'actionbuttons' style ={{backgroundColor:"red"}} onClick={()=>{navigate('/loandetails')}}>Cancel</button>
       
        <dialog id="myDialog" className="okdialog"><p>Day Closed For UserID  : {document.getElementById('user').value}</p>
            <button className="okdialogbutton" onClick={()=>{navigate('/loandetails')}}>OK</button>
        </dialog>
    </>
)
}
